export class ValidatorDef {
    public Min: number | null = null;
    public Max: number | null = null;
    public Required: boolean | null = null;
    public Type?: 'email' | 'contestant' | undefined;

    public constructor(values: {
        Min: number | null;
        Max: number | null;
        Required: boolean | null;
        Type?: 'email' | 'contestant' | undefined;
    }) {
        this.Min = values.Min;
        this.Max = values.Max;
        this.Required = values.Required;
        this.Type = values.Type;
    }
}
